var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAud = function SvgAud(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1544_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9995 20.0001C39.9995 31.0457 31.0451 40.0001 19.9995 40.0001C8.95389 40.0001 -0.000488281 31.0457 -0.000488281 20.0001C-0.000488281 20.0048 19.9995 0.0023877 19.9995 0.00012207C31.0451 0.00012207 39.9995 8.9545 39.9995 20.0001Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 0.00012207C19.999 0.00012207 19.9977 0.000204191 19.9966 0.000204191L20.0001 0.00012207Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9463 20H19.9998C19.9998 19.9819 19.9998 19.9646 19.9998 19.9465C19.982 19.9644 19.9642 19.9822 19.9463 20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10.435C20 6.91587 20 4.60985 20 0.000244141H19.9966C8.9525 0.00204102 0 8.95555 0 20.0002H10.4348V14.1242L16.3107 20.0002H19.9466C19.9645 19.9824 19.9823 19.9645 20.0001 19.9466C20.0001 18.5992 20.0001 17.397 20.0001 16.311L14.1241 10.435H20Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1181 2.60876C6.99004 4.38994 4.38957 6.99041 2.6084 10.1185V20.0001H7.82582V7.82627V7.82619H19.9997C19.9997 6.18064 19.9997 4.61298 19.9997 2.60876H10.1181Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9997 17.5407L12.894 10.4351H10.4346C10.4346 10.435 10.4346 10.4351 10.4346 10.4351L19.9996 20.0002H19.9997C19.9997 20.0002 19.9997 18.3045 19.9997 17.5407Z",
    fill: "#E4002B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0621 23.4783L13.1598 25.7734L15.6385 25.2005L14.5285 27.4898L16.5218 29.0705L14.04 29.6298L14.0469 32.1739L12.0621 30.5823L10.0775 32.1739L10.0844 29.6298L7.60254 29.0705L9.5959 27.4898L8.48574 25.2005L10.9646 25.7734L12.0621 23.4783Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9441 27.8262L30.4929 28.9738L31.7323 28.6873L31.1772 29.8319L32.174 30.6223L30.933 30.902L30.9365 32.174L29.9441 31.3781L28.9518 32.174L28.9552 30.902L27.7144 30.6223L28.711 29.8319L28.156 28.6873L29.3953 28.9738L29.9441 27.8262Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8387 15.6522L25.3875 16.7999L26.6269 16.5133L26.0719 17.6579L27.0685 18.4483L25.8276 18.728L25.831 20L24.8387 19.2042L23.8464 20L23.8497 18.728L22.6089 18.4483L23.6055 17.6579L23.0505 16.5133L24.2899 16.7999L24.8387 15.6522Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9441 8.69568L30.4929 9.84333L31.7323 9.55685L31.1773 10.7015L32.1739 11.4918L30.933 11.7715L30.9365 13.0436L29.9441 12.2477L28.9518 13.0436L28.9552 11.7715L27.7144 11.4918L28.7109 10.7015L28.156 9.55685L29.3953 9.84333L29.9441 8.69568Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4037 13.9131L34.9524 15.0607L36.1918 14.7742L35.6368 15.9188L36.6334 16.7092L35.3925 16.9889L35.3959 18.2609L34.4037 17.4651L33.4113 18.2609L33.4147 16.9889L32.1738 16.7092L33.1705 15.9188L32.6155 14.7742L33.8548 15.0607L34.4037 13.9131Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2149 20L31.6465 21.3286H33.0436L31.9133 22.1498L32.3451 23.4783L31.2149 22.6572L30.0847 23.4783L30.5164 22.1498L29.3862 21.3286H30.7832L31.2149 20Z",
    fill: "#F0F0F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1544_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "AUD.0d3ff0d6ae4a71a365b12095c29f68ce.svg";